import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";
import { TYPE_LABELS } from "@/mocks/media";

export default function MediaListItem({ item }: { item: MediaItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-secondary-300"
    >
      <div className="h-40 w-[96px] shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-44 sm:w-[112px]">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - WWW.17C`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="truncate font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <span className="rounded-md bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">
            {TYPE_LABELS[item.type]}
          </span>
        </div>
        <p className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.year}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line"></i>
            {item.region}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {item.duration}
          </span>
          <span className="flex items-center gap-1 font-semibold text-accent-600">
            <i className="ri-star-fill"></i>
            {item.rating.toFixed(1)}
          </span>
        </p>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-3 hidden flex-wrap gap-1.5 sm:flex">
          {item.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-50 px-2.5 py-0.5 text-xs text-secondary-700">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}